<template>
  <div class="row">
        <div class="col-md-8">
            <!-- <br> -->
            <div class="table-responsive p-0">
                <table class="table table-bordered">
                    <tr>
                        <th>{{$t('form.student.file')}}</th>
                        <th>{{$t('form.student.UploadTimestamp')}}</th>
                        <th>{{$t('form.student.fileName')}}</th>
                        <th>{{$t('form.student.fileDescription')}}</th>
                        <th v-if="!readonly"></th>
                    </tr>
                    <tbody>
                        <tr v-for="(file , index) in attachments" :key="index">
                            <td class="text-center">
                                <i class="fa fa-file" aria-hidden="true"></i>
                            </td>
                            <td class="text-center">
                            {{file.UploadTimestamp}}
                            </td>
                            <td>

                                <a href="#"
                                    @click.prevent="downloadAttachment(file , true)" class="mr-2">{{getAttachmentFileName(file.Name)}}</a>

                                | <a href="#" @click.prevent="downloadAttachment(file)" class="ml-2"> {{$t('button.view')}}</a>

                            </td>
                            <td>
                                <input type="text" class="form-control"
                                    v-model="attachments[index].Description">
                            </td>
                            <td v-if="!readonly">
                                <span style="color:red;cursor:pointer"
                                    @click="removeAttachment(index,file)">
                                    <i class="fa fa-times"></i>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="col-md-4" v-if="!readonly">
            <div class="form-group">
                <label class="control-label"
                    for="StatusID:">{{$t('form.student.fileAttach')}}</label>

                <vue-dropzone ref="myVueDropzone" id="dropzone"
                    :options="attachmentDropzone" @vdropzone-success="attachmentUploaded"
                    @vdropzone-error="uploadFileError" @vdropzone-processing="isLoading=true">
                </vue-dropzone>
            </div>
        </div>
    </div>

</template>


<script>

import vue2Dropzone from "vue2-dropzone";

export default {
name:'Attachments',
 props: { readonly:Boolean, attachments:Array, downloadAttachment:Function, removeAttachment:Function, attachmentUploaded:Function, attachmentDropzone:Object, getAttachmentFileName:Function, uploadFileError:Function },

components: {
      vueDropzone: vue2Dropzone,
    },
}
</script>